import React, { useState } from "react";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import { useDispatch, useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import {
  getFixer,
  getLastik,
  UpdatePriceFixer,
  UpdatePriceLastic,
} from "Stores/actions";
import * as R from "ramda";
import { Dialog, DialogActions, DialogContent, Grid, Icon } from "@material-ui/core";
import Input from "Components/Input/Input";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { toggleNFixerLastik } from "Constants/Constants";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from "react-i18next";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import showNotify from "Helpers/Notify";
import { useTheme } from "@material-ui/core/styles";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import * as Icons from "react-bootstrap-icons"

function FixerLastikDialog() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const admin = read("StypeU") === "1" ? true : false;
  const { fixerData, lastikData, selectedDasteProfile } = useSelector(
    (state) => ({
      fixerData: state.profile.fixerData,
      lastikData: state.profile.lastikData,
      selectedDasteProfile: state.profile.selectedDasteProfile,
    })
  );
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [type, setType] = useState(toggleNFixerLastik[0]);
  const [formValid, setFormValid] = useState({});
  const [controls, setControls] = useState({});

  const onEnter = async () => {
    try {
      setControls({});
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdGroupProfile: selectedDasteProfile.Id,
      };
      const validation = {};
      const inputs = {};
      const dataFixer = await dispatch(getFixer(params));
      const dataLastik = await dispatch(getLastik(params));
      if (dataFixer.length === 0 && dataLastik.length === 0) {
        showNotify({
          text: t("noData2Display"),
          customClass: "error",
        });
        handleDialog();
      }
      dataFixer.map((item) => {
        validation[`fixer_${item.Id}`] = true;
        inputs[item.Name] = {
          id: item.Id,
          type: "price",
          valueGroupPrice: +convertToEnglishNumber(
            item.GroupPrice.replaceAll(",", "")
          ),
          valueUserPrice: +convertToEnglishNumber(
            item.UserPrice.replaceAll(",", "")
          ),
          mode: "fixer",
          IsG: item.IsG,
          validation: {
            required: true,
            // isPrice: true,
          },
        };
      });
      dataLastik.map((item) => {
        validation[`lastik_${item.Id}`] = true;
        inputs[item.Name] = {
          id: item.Id,
          type: "price",
          valueGroupPrice: +convertToEnglishNumber(
            item.GroupPrice.replaceAll(",", "")
          ),
          valueUserPrice: +convertToEnglishNumber(
            item.UserPrice.replaceAll(",", "")
          ),
          mode: "lastik",
          IsG: item.IsG,
          validation: {
            required: true,
            // isPrice: true,
          },
        };
      });
      setFormValid(validation);
      setControls(inputs);
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  const onChangeRadio = (name, key, value) => {
    setType(value);
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  const setValue = (id, value, validation) => {
    const inputs = controls;
    Object.keys(inputs).map((key) => {
      if (
        id.replace("fixer_", "").replace("lastik_", "") ===
        inputs[key].id.toString()
      ) {
        if (admin && inputs[key].IsG) inputs[key].valueGroupPrice = value;
        else inputs[key].valueUserPrice = value;
      }
    });
    setControls(inputs);
    setFormValid({ ...formValid, [id]: validation });
  };

  function AdminPriceShow({ data }) {
    if (admin) return null;
    else
      return (
        <span className="underInputInfo">
          {`${t("groupPrice")}: ${data.valueGroupPrice.toLocaleString()} ${t("moneyUnit")}`}
        </span>
      );
  }

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        const inputs = controls;
        const updateFixerData = [];
        const updateLastikData = [];
        Object.keys(inputs).map((key) => {
          const newValue =
            admin && inputs[key].IsG
              ? +convertToEnglishNumber(inputs[key].valueGroupPrice)
              : +convertToEnglishNumber(inputs[key].valueUserPrice);
          if (inputs[key].mode === "fixer") {
            const pervItem = fixerData.find(
              (items) => items.Id === inputs[key].id
            );
            const pervValue =
              admin && pervItem.IsG
                ? +convertToEnglishNumber(pervItem.GroupPrice)
                : +convertToEnglishNumber(pervItem.UserPrice);
            if (pervValue !== newValue) {
              updateFixerData.push({
                Id: inputs[key].id,
                Price: newValue,
              });
            }
          } else if (inputs[key].mode === "lastik") {
            const pervItem = lastikData.find(
              (items) => items.Id === inputs[key].id
            );
            const pervValue =
              admin && pervItem.IsG
                ? +convertToEnglishNumber(pervItem.GroupPrice)
                : +convertToEnglishNumber(pervItem.UserPrice);
            if (pervValue !== newValue) {
              updateLastikData.push({
                Id: inputs[key].id,
                Price: newValue,
              });
            }
          }
        });
        if (updateFixerData.length !== 0 || updateLastikData.length !== 0) {
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
          };
          updateFixerData.length !== 0 &&
            (await dispatch(
              UpdatePriceFixer({ ...data, data: updateFixerData })
            ));
          updateLastikData.length !== 0 &&
            (await dispatch(
              UpdatePriceLastic({ ...data, data: updateLastikData })
            ));
          handleDialog();
        } else {
          handleDialog();
          // showNotify({
          //   text: t('noEditedItem'),
          //   customClass: "warning",
          // });
        }
      } catch (err) {
        console.error('[FixerLastikDialog]', err);
      }
    }
    setLoading(false);
  };

  const onExit = () => {
    setType(toggleNFixerLastik[0]);
    setLoading(false);
    setOpenDialog(false);
    setFormValid({});
    setControls({});
  };

  return (
    <>
      <MuiIconButton
        title={<Translator id={"fixer_and_rubber_pricing"} />}
        icon={<Icons.Tags size={17}/>}
        onClick={handleDialog}
        className="fix-size"
        disabled={
          selectedDasteProfile.Disable ||
          (selectedDasteProfile.IsG &&
            read("StypeU") !== "1" &&
            read("lasticRules")?.accessPrice2 === false) ||
          (selectedDasteProfile.IsG === false &&
            read("StypeU") !== "1" &&
            read("lasticRules")?.accessUpdate === false)
        }
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{
          onEnter: onEnter,
          onExit: onExit,
        }}
        onClose={handleDialog}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"fixer_and_rubber_pricing"} />}</p>
          </div>
          <DialogContent>
            <MuiRadioGroup
              name="fixerLastik"
              value={type}
              items={toggleNFixerLastik}
              onChange={onChangeRadio}
              translate={true}
              disabled={loading}
            />
            {!loading ? (
              <Grid container spacing={2} className="border-top mt-3">
                {Object.keys(controls).filter(
                  (key) => controls[key].mode === type.value
                ).length !== 0 ? (
                  Object.keys(controls)
                    .filter((key) => controls[key].mode === type.value)
                    .map((key) => {
                      return (
                        <Grid key={key} item sm={4} xs={12}>
                          <Input
                            setValue={setValue.bind(this)}
                            name={`${type.value}_${controls[key].id}`}
                            value={
                              admin && controls[key].IsG
                                ? controls[key].valueGroupPrice
                                : controls[key].valueUserPrice
                            }
                            validation={controls[key].validation}
                            label={<span>{key}</span>}
                            placeholder={key}
                            type={controls[key].type}
                            longLabel
                            endIcon={<Translator id="moneyUnit" />}
                          />
                          <AdminPriceShow data={controls[key]} />
                        </Grid>
                      );
                    })
                ) : (
                  <Grid item xs={12} className="text-center">
                    <Translator id="noData2Display" />
                  </Grid>
                )}
              </Grid>
            ) : (
              <MuiSkeleton xs={6} number={6} />
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
              disabled={loading}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
              disabled={loading}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default FixerLastikDialog;
